/**
 * conversationLinks — ce qu'ouvre un lien touché dans un message, comme dans l'ancien fil
 * (`MessageText` de `react-native-gifted-chat`) :
 *  - une adresse web s'ouvre telle quelle ; écrite sans protocole (« www. »), elle prend `https://`,
 *    sans quoi le système ne sait pas l'ouvrir ;
 *  - un e-mail ouvre la messagerie (`mailto:`) ;
 *  - un numéro propose d'appeler ou d'écrire un SMS (`tel:`, `sms:`) — la feuille de l'écran.
 */
import { type UIMessageLink } from "../../../types/studentConversation"

/** Ce qu'on fait d'un numéro : l'appeler, ou lui écrire. */
export type PhoneAction = "call" | "sms"

const WWW = /^www\./i

/** L'adresse qu'ouvre un lien. Un numéro attend le choix de l'élève (`phoneHref`). */
export function linkHref(link: UIMessageLink): string | null {
    if (link.kind === "url") return WWW.test(link.value) ? `https://${link.value}` : link.value
    if (link.kind === "email") return `mailto:${link.value}`
    return null
}

/** L'adresse qu'ouvre un numéro, selon ce que l'élève a choisi. */
export function phoneHref(phone: string, action: PhoneAction): string {
    return `${action === "call" ? "tel" : "sms"}:${phone}`
}
